// Starred email folders — the FAVORITES group at the top of the EMAIL
// section.
//
// Identifiers are either Microsoft well-known names (preferred — stable
// across reconnects) or per-mailbox folder UUIDs (custom folders).
//
// Storage: follows the ACCOUNT, not the browser (2026-08-15). These sat
// in localStorage through v1.x, so an advisor's stars silently reverted
// to the Inbox + Sent Items default on any other browser. Because that
// default is close to what most people star, it read as "some of my
// setup saved and some didn't" rather than as an outright reset — which
// is what made it confusing rather than obviously broken. Descriptor
// lives in web/src/settings/user-settings-registry.ts; existing browsers
// seed the account on first load.

import { EMAIL_FAVORITES } from "../settings/user-settings-registry";
import { useUserSetting } from "../settings/user-settings-context";

export { DEFAULT_EMAIL_FAVORITES } from "../settings/user-settings-registry";

export interface UseEmailFavoritesResult {
  favorites: Set<string>;
  isFavorite: (id: string) => boolean;
  toggle: (id: string) => void;
}

export function useEmailFavorites(): UseEmailFavoritesResult {
  const [favorites, setFavorites] = useUserSetting(EMAIL_FAVORITES);

  const toggle = (id: string): void => {
    const next = new Set(favorites);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    setFavorites(next);
  };

  return {
    favorites,
    isFavorite: (id: string) => favorites.has(id),
    toggle,
  };
}
